import { CodeHighlight } from "@/components/wysiwyg/CodeHighlight.client";
import { CommandSearchResults } from "./CommandSearchResults.client";
import { Body } from "@/components/wysiwyg/Body";
import { parse } from 'marked';

export async function CommandApp({
  resource,
  basePath,
}: {
  resource: string | null;
  basePath: string;
}) {
  return (
    <>
      {resource ? (
        <Body value={parse(resource.replaceAll('.md', ''), {async: false}) as string} />
      ) : (
        <div className="meta-content">
          <p>
            Use the searchbar above or the index listing below to find
            documentation on Acquia DAM Developer SDK.
          </p>
          <h2 className="text-lg font-display my-1 mt-4 text-gray-800 font-semibold">
            Usage
          </h2>
          <pre>
            <CodeHighlight language="bash">
              {`# Example: Accessing documentation for the AssetsApi
classes/AssetsApi`}
            </CodeHighlight>
          </pre>
          <CommandSearchResults query={""} slugBase={basePath} />
        </div>
      )}
    </>
  );
}
